// extracted by mini-css-extract-plugin
module.exports = {"countWrapper":"_8f08f50"};